module.exports = __webpack_public_path__ + "img/guide28805.ff2deae3.png";